import purify from 'dompurify'

const innerHtml = (html: string) => {
  return { dangerouslySetInnerHTML: { __html: purify.sanitize(html) } }
}

export default innerHtml
